import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { Form } from 'react-final-form';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';

import ProfilePreview from '@/profile/components/ProfilePreview';
import { updateExpertState } from '@/store/user';

const getStyles = makeStyles((theme) => ({
  form: {
    marginTop: 30,
    // @ts-expect-error TS(2339) FIXME: Property 'breakpoints' does not exist on type 'Def... Remove this comment to see the full error message
    [theme.breakpoints.down('md')]: {
      marginTop: 10,
    },
  },
}));

function CompleteProfile({ viewer, updateExpertState, ...other }: any) {
  const s = getStyles();
  const navigate = useNavigate();

  const handleSubmit = useCallback(async () => {
    await updateExpertState({
      id: viewer.id,
      expert_state: 'applied',
    });

    navigate('/dashboard');
  }, []);

  return (
    <Grid container justifyContent="center">
      <Grid item md={12} sm={12}>
        <Form
          component={ProfilePreview}
          editable
          self
          isForm
          className={s.form}
          onSubmit={handleSubmit}
          {...other}
        />
      </Grid>
    </Grid>
  );
}

CompleteProfile.propTypes = {
  profileId: PropTypes.string.isRequired,
};

// @ts-expect-error TS(2631) FIXME: Cannot assign to 'CompleteProfile' because it is a... Remove this comment to see the full error message
CompleteProfile = connect(undefined, {
  updateExpertState,
})(CompleteProfile);

export default CompleteProfile;
